import type { ComponentType } from 'react'
import { TurboMount } from 'turbo-mount'
import { registerComponent } from 'turbo-mount/react'
import { stimulus } from '~/init'
import { TextEditor } from './react/components/TextEditor'

const turboMount = new TurboMount({ application: stimulus })

function register<P extends object>(name: string, component: ComponentType<P>): void {
  registerComponent(turboMount, name, component as ComponentType)
}

register('TextEditor', TextEditor)
